import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/PortfolioScenarios/Domain/commands-core';
import { ProjectAcceptanceDTO } from '@Quest/PortfolioScenarios/Domain/dtos';
import Component from 'vue-class-component';

@Component
export default class PortfolioScenariosCommands extends VueCqrs 
{
	invokeCreatePortfolioScenarioCommandV1(workspaceId: number, corporateScenarioId: string, portfolioId: string, scenarioId: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null,
		applyBenefitsConfidenceFactor: boolean, denomination: string, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		const cmd = new c.CreatePortfolioScenarioCommandV1(workspaceId, corporateScenarioId, portfolioId, scenarioId, name, description, criteriaHierarchyId, weightsSetId,
			applyBenefitsConfidenceFactor, denomination, approvalAcceptedStatusId, approvalRejectedStatusId);
		this.$command(cmd, scenarioId);
	}

	invokeUpdatePortfolioScenarioCommandV1(workspaceId: number, corporateScenarioId: string, portfolioId: string, scenarioId: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null,
		applyBenefitsConfidenceFactor: boolean, denomination: string, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		const cmd = new c.UpdatePortfolioScenarioCommandV1(workspaceId, corporateScenarioId, portfolioId, scenarioId, name, description, criteriaHierarchyId, weightsSetId,
			applyBenefitsConfidenceFactor, denomination, approvalAcceptedStatusId, approvalRejectedStatusId);
		this.$command(cmd, scenarioId);
	}

	invokeSaveReviewGridCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, grid: string)
	{
		const cmd = new c.SaveReviewGridCommandV1(workspaceId, portfolioId, scenarioId, grid);
		this.$command(cmd, scenarioId);
	}

	invokeClonePortfolioScenarioCommandV1(workspaceId: number, portfolioId: string, sourceId: string, cloneId: string, cloneName: string)
	{
		const cmd = new c.ClonePortfolioScenarioCommandV1(workspaceId, portfolioId, sourceId, cloneId, cloneName);
		this.$command(cmd, cloneId);
	}

	invokeDeletePortfolioScenarioCommandV1(workspaceId: number, portfolioId: string, scenarioId: string)
	{
		const cmd = new c.DeletePortfolioScenarioCommandV1(workspaceId, portfolioId, scenarioId);
		this.$command(cmd, scenarioId);
	}

	invokeConnectToCorporateScenarioCommandV1(workspaceId: number, portfolioId: string, portfolioScenarioId: string, corporateScenarioId: string)
	{
		const cmd = new c.ConnectToCorporateScenarioCommandV1(workspaceId, portfolioId, portfolioScenarioId, corporateScenarioId);
		this.$command(cmd, portfolioScenarioId);
	}


	invokeOptimizeSelectionCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, resources: string[], totalCost: number | null, opex: number | null,
		capex: number | null, othex: number | null, expenses: number | null, opexExpenses: number | null, applyBenefitsConfidenceFactor: boolean)
	{
		const cmd = new c.OptimizeSelectionCommandV1(workspaceId, portfolioId, scenarioId, resources, totalCost, opex, capex, othex, expenses, opexExpenses, applyBenefitsConfidenceFactor);
		this.$command(cmd, scenarioId);
	}


	invokeAddProjectsToScenarioCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, viewDefId: string | null, kanbanStatusId: number | null)
	{
		const cmd = new c.AddProjectsToScenarioCommandV1(workspaceId, portfolioId, scenarioId, viewDefId, kanbanStatusId);
		this.$command(cmd, scenarioId);
	}

	invokeRemoveProjectsFromScenarioCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.RemoveProjectsFromScenarioCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateProjectScenarioAcceptanceCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], acceptance: string)
	{
		const cmd = new c.UpdateProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId, projectIds, acceptance);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateProjectScenarioStartDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], startDate: MonthYear | null)
	{
		const cmd = new c.UpdateProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds, startDate);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateProjectScenarioMinStartDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], minStartDate: MonthYear | null)
	{
		const cmd = new c.UpdateProjectScenarioMinStartDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds, minStartDate);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateProjectScenarioMaxStartDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], maxStartDate: MonthYear | null)
	{
		const cmd = new c.UpdateProjectScenarioMaxStartDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds, maxStartDate);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateProjectScenarioCommitmentDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[], commitmentDate: MonthYear | null)
	{
		const cmd = new c.UpdateProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds, commitmentDate);
		this.$command(cmd, scenarioId);
	}


	invokeLockProjectScenarioAcceptanceCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.LockProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeUnlockProjectScenarioAcceptanceCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.UnlockProjectScenarioAcceptanceCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeLockProjectScenarioStartDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.LockProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeUnlockProjectScenarioStartDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.UnlockProjectScenarioStartDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeLockProjectScenarioCommitmentDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.LockProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}

	invokeUnlockProjectScenarioCommitmentDateCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectIds: string[])
	{
		const cmd = new c.UnlockProjectScenarioCommitmentDateCommandV1(workspaceId, portfolioId, scenarioId, projectIds);
		this.$command(cmd, scenarioId);
	}


	invokeApproveScenarioProjectCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, projectId: string)
	{
		const cmd = new c.ApproveScenarioProjectCommandV1(workspaceId, portfolioId, scenarioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeApproveScenarioCommandV1(workspaceId: number, portfolioId: string, scenarioId: string)
	{
		const cmd = new c.ApproveScenarioCommandV1(workspaceId, portfolioId, scenarioId);
		this.$command(cmd, scenarioId);
	}

	invokeUpdateScenarioAcceptancesCommandV1(workspaceId: number, portfolioId: string, scenarioId: string, acceptances: ProjectAcceptanceDTO[])
	{
		const cmd = new c.UpdateScenarioAcceptancesCommandV1(workspaceId, portfolioId, scenarioId, acceptances);
		this.$command(cmd, scenarioId);
	}
}
